/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   useRegisterCriticalAsset.ts
 */

import { useContext } from 'react'

import {
  criticalAssetsContext,
  defaultCriticalAssetsContext,
} from './criticalAssetsContext'

export const useRegisterCriticalAsset = () => {
  /* istanbul ignore next */
  const context =
    useContext(criticalAssetsContext) ?? defaultCriticalAssetsContext
  return context.registerCriticalAsset
}
